import React, { useEffect, useState } from 'react';
import './cohort-view-mc.styles.scss'
import { useNavigate, useParams } from 'react-router-dom';
import ThreeDotsLoaderSmall from '../loader/three-dots-loader-small.component';
import { format } from 'date-fns';
import StatusBarWithIcons from '@/components/HOME/my-microcredentials/status-bar-with-icons.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';
import { ModalAlert } from '../modal/modal.component';

const CohortViewMc = ({
    cohort,
    userList,
    mcList,
    progressNumbers
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const { mcKey } = useParams();
    const [ mc, setMc ] = useState(null);
    const [ nfeRegs, setNfeRegs ] = useState({});
    const [ loading, setLoading ] = useState(true);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!mcKey || !mcList) return;
        setMc(mcList[mcKey]);
    }, [mcKey, mcList])

    useEffect(() => {
        if (!mc) return;
        getMcNfeRegs();
    }, [mc])

    async function getMcNfeRegs() {
        const res = await UseCloudFunction(
            'getMcUserListFromNfe',
            {
                'mcData': mc,
                'profile': userProfile
            }
        )
        console.log(res);
        let regs = {}
        for (let reg of res) {
            regs[reg.cst_key] = new Date(reg.add_date).getTime();
        }
        setNfeRegs(regs);
        setLoading(false);
    }

    return (
        <div className='cohort-view-mc'>
            {
                (mc && cohort) &&
                <div className='cohort-view-mc-content'>
                    <div className='mc-title'>
                        <div>
                            <img src={mc.imageUrl} className='mc-icon' />
                        </div>
                        <div className='mc-name'>
                            <div className='name'>{mc.name}</div>
                            <div className='meta'>{mc.mc_key}</div>
                        </div>
                        <div className='cohort-info'>
                            {cohort.name}
                            <img src={cohort.icon} className='cohort-icon' />
                        </div>
                    </div>
                    <hr />
                    
                    <section className='mc-user-list'>
                    {
                        (userList) &&
                        Object.values(userList)
                        .sort((a, b) => 
                            a.lName.toLowerCase() > b.lName.toLowerCase() 
                            ? 1 
                            : (
                                a.lName.toLowerCase() === b.lName.toLowerCase()
                                ? (
                                    a.fName.toLowerCase() > b.fName.toLowerCase() 
                                    ? 1 
                                    : -1
                                )
                                : -1 
                            )
                        )
                        .map(u => (
                            <div key={u.cst_key} className='g-list-item' >
                                <div className=' progress-bar'>
                                    <div className='title-box'>
                                        <div className=''>
                                            <UserIcon profile={u} small={true} />
                                        </div>
                                        <div>
                                            {u.fName} {u.lName}
                                            {/* <div className='meta'>{mc.mc_key}</div> */}
                                            {
                                                (loading)
                                                ?
                                                <div className='meta'><ThreeDotsLoaderSmall /></div>
                                                :
                                                (nfeRegs[u.cst_key]) 
                                                ?
                                                <div className='meta'>Purchased {format(new Date(nfeRegs[u.cst_key]), "P")}</div>
                                                :
                                                <div className='meta'>Not yet purchased</div>
                                            }
                                        </div>
                                    </div>
                                    <div className='icon-box'>
                                        {
                                            (nfeRegs[u.cst_key]) &&
                                            <>
                                            <StatusBarWithIcons 
                                                progressNumber={
                                                    progressNumbers[mc.mc_key] 
                                                    ? progressNumbers[mc.mc_key][u.cst_key] 
                                                    : 0
                                                } 
                                                mcData={mc} />
                                            {
                                                (progressNumbers[mc.mc_key] && progressNumbers[mc.mc_key][u.cst_key]?.legacy) 
                                                ?
                                                <button 
                                                    className='g-button small-btn'
                                                    onClick={() => setAlertMessage('This Micro-Credential was completed in a legacy version of this platform. There is no data in this version.')}>
                                                    <FontAwesomeIcon icon={faEyeSlash} />
                                                </button>
                                                :
                                                <button 
                                                    className={`g-button small-btn`}
                                                    onClick={() => navigate(`../progress/${mc.mc_key}_${u.cst_key}`)}>
                                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                </button>
                                            }
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    </section>
                </div>
            }
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
        </div>
    )
}

export default CohortViewMc